import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import {
  CategoryCardWithGAClickButton,
  CategoryCardHeader,
  CategoryCardMedia,
  Section,
  SectionSubTitle,
  SwiperSlide,
  SwiperWithNavigation,
} from 'common/components';
import { createElementKey } from 'utils';
import { analyticsUtils, ClickButtonElementName } from 'utils/analytics-utils';
import { STORAGE_ELEMENT_BLOCK } from '../../storage-constants';
import { storageAdditionalSlide } from './storage-additional-section-styles';
import {
  STORAGE_ADDITIONAL_ITEM_LIST,
  StorageAdditionalItemStructure,
} from './storage-additional-section-constants';

export const StorageAdditionalSection = () => {
  const { t } = useTranslation();
  /**
   * Обработчик нажатия кнопки "Следующий слайд"
   */
  const handleNextSlideBtnClick = useCallback(() => {
    analyticsUtils.clickButtonEvent(
      STORAGE_ELEMENT_BLOCK,
      ClickButtonElementName.SwitchForward,
      t('utp-section.all-purchases.card-description')
    );
  }, [t]);

  /**
   * Обработчик нажатия кнопки "Предыдущий слайд"
   */
  const handlePrevSlideBtnClick = useCallback(() => {
    analyticsUtils.clickButtonEvent(
      STORAGE_ELEMENT_BLOCK,
      ClickButtonElementName.SwitchBackward,
      t('utp-section.all-purchases.card-description')
    );
  }, [t]);

  return (
    <Section>
      <SectionSubTitle margin="m">{t('utp-section.all-purchases.card-description')}</SectionSubTitle>
      <SwiperWithNavigation
        onSlideNextTransitionEnd={handleNextSlideBtnClick}
        onSlidePrevTransitionEnd={handlePrevSlideBtnClick}
        slidesPerView="auto"
        watchOverflow>
        {STORAGE_ADDITIONAL_ITEM_LIST.map(
          ({ name, imgSrc, link }: StorageAdditionalItemStructure, index: number) => (
            <SwiperSlide
              className={storageAdditionalSlide}
              key={createElementKey('storage-add-item', index)}>
              <CategoryCardWithGAClickButton
                elementBlock={STORAGE_ELEMENT_BLOCK}
                elementName={t(name)}
                elementText={t('utp-section.all-purchases.card-description')}
                {...link}>
                <CategoryCardHeader title={t(name)} />
                <CategoryCardMedia src={imgSrc} alt={t(name) || ''} width={156} height={140} loading="lazy" />
              </CategoryCardWithGAClickButton>
            </SwiperSlide>
          )
        )}
      </SwiperWithNavigation>
    </Section>
  );
};
